import Link from "next/link";

export type SecondaryButtonProps = {
  text: string;
  navigateTo?: string;
  target?: string;
  className?: string;
  onClick?: () => void;
};

export const SecondaryButton = ({
  text,
  navigateTo,
  target = "_self",
  className = "",
  onClick,
}: SecondaryButtonProps) => {
  const baseClasses =
    "bg-[#F7F7F7] text-tertiary text-sm lg:text-base uppercase px-2 lg:px-6 py-2 lg:py-4 border border-tertiary hover:bg-tertiary hover:text-primary transition-all duration-300 w-fit";

  const buttonClasses = `${baseClasses} ${className}`;

  if (navigateTo) {
    return (
      <Link
        href={navigateTo}
        className={buttonClasses}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        onClick={onClick}
      >
        {text}
      </Link>
    );
  }

  return (
    <button className={buttonClasses} onClick={onClick}>
      {text}
    </button>
  );
};
